import React from 'react';
import * as currency from "@shopify/theme-currency";
import { TwitterIcon } from 'react-share';

export const PaymentOptions = (price:any) => {
  const base_url = "https://wig-builder.s3.amazonaws.com/"
  const singlePayment=Math.ceil(price.price/400)

  return (
    <div className="mt-2 text-[0.6rem] font-medium p-[.5rem]">
      We offer Shop Now, Pay Later payment options
      <br />
      Available in 4 interest-free payments of ${singlePayment}
      <br />
      <img style={{display: "inline"}} className="p-[0.2rem] w-[3rem]" src={base_url + "affirm-parfait-cart.png"} alt="Affirm" />
      <img style={{display: "inline"}} className="p-[0.2rem] w-[3rem]" src={base_url + "afterpay-parfait-cart.png"} alt="AfterPay" />
      <img style={{display: "inline"}} className="p-[0.2rem] w-[3rem]" src={base_url + "sezzle-parfait-cart.png"} alt="Sezzle" />

    </div>
    
  )
}